(function($) {
    $(document).ready(function() {
        if ($(".sticky-nav").length > 1) {
            $(".sticky-nav:eq(0)").hide();
        }

        if ($(".secondary-pages").length > 0) {
            var page_url = window.location.pathname;
            var new_url = page_url.slice(0, page_url.lastIndexOf('/'));
            if (page_url.indexOf('/') > -1) {
                $('.parent-sticky .sticky-nav ul li a').each(function() {
                    var value = $(this).attr('href');
                    $(this).attr('href', '' + new_url + '' + value);
                });
            }
        }
        if ($(".secondary-pages .sticky-nav").length === 2) {
            $(".parent-sticky").remove();
        }

        if ($(".sticky-nav").length === 2) {
            $('.fourth-level-banner').next().remove();
        }
        if ($(".focus-area .sticky-nav").length === 2) {
            $(".taxonomy-sticky-nav").remove();
        }
        initActiveScrollSelector();
        $(".sticky-nav").css("opacity", "1");

        // var sticky_length = jQuery(".sticky-nav").length;
        // if (sticky_length === 2) {
        //     $(".parent-sticky").remove();
        // }
    });

    function fixed_menu() {
        if ($(".sticky-nav").length === 1 || $(".sticky-nav").length === 2) {
            var scroll = $(document).scrollTop(),
                bannerHeight = $(".sticky-nav").offset().top - $("header").outerHeight();
            isNavSticky = true;
            isClicked = false;
            $(window).on('scroll load', function() {
                var scrolled = jQuery(document).scrollTop();
                if ((scrolled > scroll)) {
                    if (scrolled >= bannerHeight && isNavSticky === true) {
                        $(".header").addClass("fixed");
                        isNavSticky = false;
                    }
                    $(".header").removeClass("off-canvas");
                } else if ((scrolled < scroll)) {
                    if (scrolled > bannerHeight && isNavSticky === false) {

                        if (isClicked === true) {
                            $(".header.fixed").removeClass("off-canvas");
                        } else if (isClicked === false) {
                            $(".header.fixed").addClass("off-canvas");
                        }
                        isNavSticky = true;
                    } else if (scrolled < bannerHeight && isNavSticky === true) {
                        $(".header").removeClass("off-canvas").removeClass("fixed");

                        isClicked = false;
                        isNavSticky = false;
                    } else if (scrolled > bannerHeight && isClicked === true) {
                        isClicked = false;

                    }
                    isNavSticky = true;
                }
                scroll = $(document).scrollTop();

                if ($(".header").hasClass('off-canvas')) {
                    $(".sticky-nav").removeClass('off-canvas');
                } else {
                    $(".sticky-nav").addClass('off-canvas');
                }
            });
        }
    }

    function initActiveScrollSelector() {
        if ($(".sticky-nav").length === 1 || $(".sticky-nav").length === 2) {
            var minusHeight = $(".sticky-nav").outerHeight() + $("header").outerHeight() - 80;
            $(window).on("scroll", function() {

                var scroll = $(window).scrollTop();
                var activeSelector = $('section');
                var nav = $('.sticky-nav ul');

                activeSelector.each(function() {
                    var top = $(this).offset().top - minusHeight - 80,
                        bottom = top + $(this).outerHeight();
                    if (scroll >= top && scroll <= bottom) {
                        nav.find('li.active').siblings('li.active').removeClass('active');
                        nav.find('a[href="#' + $(this).attr("id") + '"]').parent("li").addClass("active");
                        nav.find("li.active a").clone().appendTo(".mobile-nav p");
                    } else if (scroll >= bottom) {
                        // nav.find("li.active").removeClass("active");
                        $(".mobile-nav p").empty();
                        nav.find("li.active a").clone().appendTo(".mobile-nav p");
                    }
                });
                if (!$(".mobile-nav p").html()) {
                    var firstItemSpan = $('.sticky-nav ul li:first-of-type span').clone();
                    if (firstItemSpan.length) {
                        firstItemSpan.appendTo(".mobile-nav p");
                    } else {
                        $(".sticky-nav ul li:first-of-type a").clone().appendTo(".mobile-nav p");
                    }
                    return false;
                }
            });
            var winWidth = $(window).width();
            $(document).on("click", '.sticky-nav a[href^="#"]', function(e) {
                e.preventDefault();
                $(".sticky-nav ul li a").clone().appendTo(".mobile-nav p");
                var $top = $($(this).attr("href")).offset().top;
                setTimeout(function() {
                    $(".header").removeClass("off-canvas");
                    $(".sticky-nav").addClass("off-canvas");
                }, 1000);

                if (winWidth > 1024) {
                    $("html, body").animate({
                            scrollTop: $top - minusHeight,
                        },
                        1000,
                        "linear"
                    );
                }
                if (winWidth < 1024) {
                    $("html, body").animate({
                        scrollTop: $top - minusHeight - 64,
                    }, 1000, "linear");

                    setTimeout(function() {
                        $("html, body").animate({
                            scrollTop: $top - minusHeight - 60,
                        }, 1000, "linear");
                    }, 1200);

                }
            });
            $('.sticky-nav .btn-wrapper a[href^="#"]').on("click", function(e) {
                e.preventDefault();
                $(".sticky-nav .row-wrapper").removeClass("active");
            });
        }
    }

    $(window).on("load", function () {
        if ($(".sticky-nav").length === 2) {
            $('.fourth-level-banner').next().remove();
        }
        $(".sticky-nav .mobile-nav p").empty();
        if ($('.sticky-nav ul li:first-of-type span').length) {
            $('.sticky-nav ul li:first-of-type span').clone().appendTo(".mobile-nav p");
        } else {
            $(".sticky-nav ul li:first-of-type a").clone().appendTo(".mobile-nav p");
        }
        fixed_menu();
        // var btnWidth = $(".sticky-nav .btn-wrapper").outerWidth() + "px", 
        // $(".sticky-nav ul").css({ width: "calc(100% - " + btnWidth + ")" });
        headerHeight = $("header").outerHeight();
        if ($(".sticky-nav").length === 1 || $(".sticky-nav").length === 2) {


            $(document).on("click", '.sticky-nav.with-list p', function(e) {
                $(this).toggleClass('rotate'); 
                $(this).next('.drop-down').slideToggle();
            });

            function applyDropdownInteraction() {
                $('.sticky-nav.with-dropdown li:has(.dropdown-list)').off('mouseenter mouseleave click');
                if ($(window).width() > 1024) {
                    $('.sticky-nav.with-dropdown li:has(.dropdown-list)').on('mouseenter', function() {
                        $(this).addClass('rotate');
                    }).on('mouseleave', function() {
                        $(this).removeClass('rotate');
                    });
                    $('.sticky-nav.with-dropdown .btn-wrapper .single-btn-wrap:has(.dropdown-list)').on('mouseenter', function() {
                        $(this).addClass('rotate');
                    }).on('mouseleave', function() {
                        $(this).removeClass('rotate');
                    });
                } else {
                    $('.sticky-nav.with-dropdown li:has(.dropdown-list)').on('click', function() {
                        $(this).toggleClass('rotate');
                    });
                    $('.sticky-nav.with-dropdown .btn-wrapper .single-btn-wrap:has(.dropdown-list)').on('click', function() {
                        $(this).toggleClass('rotate');
                    });
                }
            }
            applyDropdownInteraction();
            $(window).on('resize', function() {
                applyDropdownInteraction();
            });          
            
            $(document).on("click", '.sticky-nav ul li a', function(e) {
                $(".sticky-nav ul li").removeClass("active");
                $(this).parent().addClass("active");
                $('.sticky-nav .row-wrapper').removeClass('active');
                $(".sticky-nav .mobile-nav p").empty();
                $(this).clone().appendTo(".mobile-nav p");
                $('.sticky-nav.with-list p').removeClass('rotate');
                $('.sticky-nav.with-list .drop-down').slideUp();

                //    go to url if there are no #
                const url = window.location.pathname;
                const Href = $(this).attr("href");
                if ((url.indexOf('/Href/') >= 0) && (Href.indexOf('#') == -1)) {
                    window.location.href = Href;
                    location.reload(true);
                }

            });

            var stickyOffsetTop = $(".sticky-nav").offset().top - headerHeight;
            $(window).scroll(function() {
                var scroll = $(window).scrollTop();
                if (scroll >= stickyOffsetTop) {
                    $(".sticky-nav").addClass("fixed-nav");
                    $('.sticky-nav').next().addClass('top-space');
                    // if ($(window).width() < 992) {
                    //     $('.sticky-nav .row-wrapper').removeClass('active');
                    // }
                } else {
                    $(".sticky-nav").removeClass("fixed-nav");
                    $('.sticky-nav').next().removeClass('top-space');
                    // if ($(window).width() < 992) {
                    //     $('.sticky-nav .row-wrapper').addClass('active');
                    // }
                }
            });
            $(document).on("click", '.sticky-nav .mobile-nav', function(e) {
                e.stopPropagation();
                e.preventDefault();
                $('.sticky-nav .row-wrapper').toggleClass('active');
            });
            initActiveScrollSelector();
            setTimeout(function() {
                $(".sticky-nav").css("opacity", "1");
            }, 500);
        }
        // $(document).on("click", function() {
        //     $(".row-wrapper").removeClass("active");
        // });

        if ($('body').find('.publication-wrapper, #block-hoover-content').length < 0) {
            //code for if a section has no id then relatively sticky nav will be removed automatically
            setTimeout(function() {
                if ($(".sticky-nav").length === 1 || $(".sticky-nav").length === 2) {
                    var secId = [];
                    var stickyId = [];
                    $(".sticky-nav ul li").find("a").each(function() {
                        stickyId.push($(this).attr('href').replace('#', ''));
                    });

                    $("section").each(function() {
                        secId.push($(this).attr('id'));
                    });

                    stickyId = stickyId.filter(val => !secId.includes(val));
                    $.each(stickyId, function(index, value) {
                        var stickyHref = value.replace('', '#');
                        $(".sticky-nav ul li").find('a[href$="' + stickyHref + '"]').parent().remove();
                    });
                }
                if ($('body .sticky-nav ul li').length < 1) {
                    $('body .sticky-nav').hide();
                }
            }, 500);
        }
        if ($('body').find('#block-hoover-content').length > 0) {
            //code for if a section has no id then relatively sticky nav will be removed automatically
            setTimeout(function() {
                if ($(".sticky-nav").length === 1 || $(".sticky-nav").length === 2) {
                    var secId = [];
                    var stickyId = [];
                    $(".sticky-nav ul li").find("a").each(function() {
                        stickyId.push($(this).attr('href').replace('#', ''));
                    });

                    $("section").each(function() {
                        secId.push($(this).attr('id'));
                    });

                    stickyId = stickyId.filter(val => !secId.includes(val));
                    $.each(stickyId, function(index, value) {
                        if (!$(".secondary-pages").length > 0) {
                            var stickyHref = value.replace('', '#');
                            $(".sticky-nav ul li").find('a[href$="' + stickyHref + '"]').parent().remove();
                        }
                    });
                }
                if ($('body .sticky-nav ul li').length < 1) {
                    $('body .sticky-nav').hide();
                }
            }, 500);

            if ($('body').find('#block-hoover-content .secondary-pages').length > 0) {
                //code for if a section has no id then relatively sticky nav will be removed automatically
                setTimeout(function() {
                    if ($(".sticky-nav").length === 1 || $(".sticky-nav").length === 2) {
                        var secId = [];
                        var stickyId = [];
                        $(".sticky-nav ul li").find("a").each(function() {
                            stickyId.push($(this).attr('href').replace('#', ''));
                        });

                        $("section").each(function() {
                            secId.push($(this).attr('id'));
                        });

                        stickyId = stickyId.filter(val => !secId.includes(val));
                        $.each(stickyId, function(index, value) {
                            var stickyHref = value.replace('', '#');
                            $(".sticky-nav ul li").find('a[href$="' + stickyHref + '"]').parent().show();
                        });
                    }
                    if ($('body .sticky-nav ul li').length < 1) {
                        $('body .sticky-nav').show();
                    }
                }, 500);
            }
        }

        var $list = $(".sticky-nav.with-list ul");

        $list.children().detach().sort(function(a, b) {
            return $(a).text().localeCompare($(b).text());
        }).appendTo($list);
    });

    // $(window).on('load resize', function() {
    //     if ($(window).width() < 992) {
    //         $('.sticky-nav .row-wrapper').addClass('active');
    //     } else {
    //         $('.sticky-nav .row-wrapper').removeClass('active');
    //     }
    // })
 
})(jQuery);